export default "__VITE_ASSET__d35d7aca__"